/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWebAuthnVerificationBeginResponse
 */
export interface OutputWebAuthnVerificationBeginResponse {
    /**
     * WebAuthn PublicKeyCredentialRequestOptions
     * @type {object}
     * @memberof OutputWebAuthnVerificationBeginResponse
     */
    publicKey?: object;
}

/**
 * Check if a given object implements the OutputWebAuthnVerificationBeginResponse interface.
 */
export function instanceOfOutputWebAuthnVerificationBeginResponse(value: object): boolean {
    return true;
}

export function OutputWebAuthnVerificationBeginResponseFromJSON(json: any): OutputWebAuthnVerificationBeginResponse {
    return OutputWebAuthnVerificationBeginResponseFromJSONTyped(json, false);
}

export function OutputWebAuthnVerificationBeginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWebAuthnVerificationBeginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'publicKey': json['publicKey'] == null ? undefined : json['publicKey'],
    };
}

export function OutputWebAuthnVerificationBeginResponseToJSON(value?: OutputWebAuthnVerificationBeginResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'publicKey': value['publicKey'],
    };
}

